import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContainerOwnerService {

  private apiUrl = environment.apiUrl + environment.containerOwnerPath;
  
  constructor(private http: HttpClient) {}

  getContainerOwners(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  getContainerOwnerById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  createContainerOwner(containerOwner: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, containerOwner);
  }

  updateContainerOwner(id: number, containerOwner: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, containerOwner);
  }

  deleteContainerOwner(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}
